export const ID_KEY_NAME = 'id';
export const TEXT_KEY_NAME = 'text';
export const DO_NOT_EMIT_EVENTS = true;

export const SELECT_TYPE_DEVICE_TYPE = 'deviceType';
export const SELECT_TYPE_MANUFACTURER = 'manufacturer';
export const SELECT_TYPE_MODEL = 'model';

export const SELECT_TYPE_REGION = 'region';
export const SELECT_TYPE_BUILDING = 'building';
export const SELECT_TYPE_AREA = 'area';
export const SELECT_TYPE_ROOM = 'room';
export const NULL_REGION_ID = null;
export const NULL_BUILDING_ID = null;